import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { useStyles } from './styles';
import { UserTable } from 'components/Tables/UserTable/userTable';

const Users: FC = observer(() => {
  const classes = useStyles();
  return (
    <Container maxWidth='xl' className={classes.container}>
      <UserTable />
    </Container>
  );
});

export default Users;
